import { linkToAssignmentPage } from "../../links";

export function linkToShareAssignment(classId?: string, assignmentId?: string) {
  return `${linkToAssignmentPage(classId, assignmentId)}/share`;
}
